'use strict';

const {
	section, h1, h2, h3, hr, header, i, ul, li, a, span, img,
	table, thead, tbody, tr, td, th, form, input, button, label
} = require('iblokz-snabbdom-helpers');

const {obj} = require('iblokz-data');

// home / about render via layout.yml static widgets (home-page-layout / about-page-layout)
const pages = {
	default: () => [],
	admin: require('./pages/admin'),
	articles: require('./pages/articles'),
	calendar: require('./pages/events'),
	events: require('./pages/events'),
	projects: require('./pages/projects'),
	profiles: require('./pages/profiles'),
	links: require('./pages/links'),
	contact: require('./pages/contact')
};

module.exports = ({state, actions, i18n}) => section('.content', [
	obj.switch(state.router.path, pages)({state, actions, i18n})
]);
